import { toast } from 'react-toastify';

import { tags as applicationTags } from './application';
import { apiSlice } from '../apiSlice';
import axios from '../../utils/axios';
import { toastDownloadError } from '../../utils/helpers';

const tags = {
  documents: 'documents',
};

const documentsApi = apiSlice
  .enhanceEndpoints({ addTagTypes: Object.values(tags) })
  .injectEndpoints({
    endpoints: (build) => ({

      getDocuments: build.query({
        queryFn: async (_, api) => {
          try {
            const response = await axios({
              url: `${baseURL}/documents`,
              method: 'GET',
            });

            // Force meter_documents refresh (is updated on this fetch route)
            if (response.data.meter_documents) {
              api.dispatch(documentsApi.util.invalidateTags([applicationTags.profile, applicationTags.afrProfile]));
            }

            return { data: response.data.documents };
          } catch (error) {
            console.error(error.response);
            return { error: error.message };
          }
        },
        providesTags: [tags.documents],
      }),



      uploadDocuments: build.mutation({
        queryFn: async (payload) => {
          const { type, file, afr_uuid } = payload;
          try {
            const formData = new FormData();
            formData.append('document', file);
            if (afr_uuid) formData.append('afr_uuid', afr_uuid);
            const response = await axios({
              url: `${baseURL}/documents/upload/${type}`,
              method: 'POST',
              data: formData,
              headers: { 'content-type': 'multipart/form-data' },
            });
            toast.success('Document Uploaded');
            return { data: response.data };
          } catch (error) {
            console.error(error.response);
            return { error: error.message };
          }
        },
        invalidatesTags: (result, error) => (error ? [] : [...Object.values(tags), applicationTags.profile, applicationTags.afrProfile]), // invalidates applicant and afrProfile as well
      }),



      downloadDocument: build.query({
        queryFn: async ({ document_uuid }) => {
          try {
            const response = await axios({
              url: `${baseURL}/documents/download/${document_uuid}`,
              method: 'GET',
              responseType: 'blob',
            });
            const a = document.createElement('a');
            const [, fileName] = response.headers['content-disposition'].split('filename=');
            a.download = decodeURI(fileName);
            a.href = window.URL.createObjectURL(new Blob([response.data]));
            document.body.append(a);
            a.click();
            return { data: fileName };
          } catch (error) {
            console.error(error.response);
            toastDownloadError(error);
            return { error: error.message };
          }
        },
        providesTags: [],
      }),



      downloadTemplateDocument: build.query({
        queryFn: async (payload) => {
          try {
            const response = await axios({
              url: `${baseURL}/document-templates/${payload}`,
              method: 'GET',
              responseType: 'blob',
            });
            const a = document.createElement('a');
            const [, fileName] = response.headers['content-disposition'].split('filename=');
            a.download = decodeURI(fileName);
            a.href = window.URL.createObjectURL(new Blob([response.data]));
            document.body.append(a);
            a.click();
            return { data: fileName };
          } catch (error) {
            console.error(error.response);
            toast.error('It looks like something went wrong. Please try again.');
            return { error: error.message };
          }
        },
        providesTags: [],
      }),



      uploadManualSignature: build.mutation({
        queryFn: async ({ file }) => {
          try {
            const formData = new FormData();
            formData.append('document', file);
            const response = await axios({
              url: `${baseURL}/documents/upload/signatures/manual`,
              method: 'POST',
              data: formData,
              headers: { 'content-type': 'multipart/form-data' },
            });
            toast.success('Document Uploaded');
            return { data: response.data };
          } catch (error) {
            console.error(error.response);
            return { error: error.message };
          }
        },
        invalidatesTags: (result, error) => (error ? [] : [...Object.values(tags), applicationTags.profile, applicationTags.afrProfile]), // invalidates applicant and afrProfile as well
      }),



      uploadAFRManualSignature: build.mutation({
        queryFn: async ({ file, afr_uuid }) => {
          try {
            const formData = new FormData();
            formData.append('document', file);
            const response = await axios({
              url: `${baseURL}/afr/signatures/upload/manual/${afr_uuid}`,
              method: 'POST',
              data: formData,
              headers: { 'content-type': 'multipart/form-data' },
            });
            toast.success('Document Uploaded');
            return { data: response.data };
          } catch (error) {
            console.error(error.response);
            return { error: error.message };
          }
        },
        invalidatesTags: (result, error) => (error ? [] : [...Object.values(tags), applicationTags.profile, applicationTags.afrProfile]), // invalidates applicant and afrProfile as well
      }),

    }),
  });

export const {
  useGetDocumentsQuery,
  useLazyDownloadTemplateDocumentQuery,
  useUploadDocumentsMutation,
  useLazyDownloadDocumentQuery,
  useUploadManualSignatureMutation,
  useUploadAFRManualSignatureMutation,
} = documentsApi;
